module.exports = __webpack_public_path__ + "static/img/TZ@2x.b838b1bb.jpg";